import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import store, { RequestStatus } from '@src/store/index.js';
import Loader from '@src/components/Loader/Loader.jsx';
import natsLogoWhiteSvg from '@assets/nats-logo-white.svg';

import './Auth.css';

function renderLoading() {
  return (
    <div className="authBody">
      <p className="authLoaderText">Please wait while we check if<br />you are currently logged in...</p>
      <Loader className="authLoader" />
    </div>
  );
}

function renderPortal() {
  return (
    <div className="authBody">
      <div className="authPortal">
        <section className="authSection">
          <p className="authSectionText">If you work for NATS,<br />please login.</p>
          <a href={store.getLoginUrl()}>
            <button className="btn authSectionBtn">NATS Login</button>
          </a>
        </section>
        <section className="authSection">
          <p className="authSectionText">Other delegates, please<br />enter as a guest.</p>
          <button className="btn authSectionBtn" onClick={() => store.skipAuth()}>Enter as guest</button>
        </section>
      </div>
    </div>
  );
}

export default function Auth() {
  const { status, error } = store.user.use();
  return (
    <div className="authContainer">
      <div className="authFrame">
        <div className="authHeader">
          <img className="authBrandLogo" alt="NATS Logo" src={natsLogoWhiteSvg} draggable="false" />
          <p className="authTitle">Welcome to the<br /><strong>Scenario Player</strong></p>
        </div>
        {status !== RequestStatus.LOADED ? renderLoading() : renderPortal()}
        <div className={classNames('authFooter', !error && 'hidden')}>
          <p className="authMessage">{error}</p>
        </div>
      </div>
    </div>
  );
}
